import type { TranslationLang, CountryName, Locale } from '@skytech/types'

export const ELKJOP_DEVICE_DEALER_IDS = [2837, 5182]
export const MOBIT_DEVICE_DEALER_ID = 2802 as const

export const TELEHUSET_CUSTOMER_ID = 1000402 as const
export const SKYTECH_CUSTOMER_ID = 1 as const
export const MULTI_CONSULT_CUSTOMER_IDS = [3, 1000373, 1000383, 1000384]
export const ELKJOP_CUSTOMER_IDS = [1000075, 1000072]
export const MOBIT_CUSTOMER_IDS = [1000463, 1000402]
export const INTUNOR_CUSTOMER_IDS = [
  1000657, 1000621, 1000617, 1000480, 1000479, 1000478, 1000477, 1000476, 1000475, 1000474,
]
export const KPMG_CUSTOMER_IDS = [1000108, 1000109]

export const MULTI_CONSULT_CUSTOMER_HEAD_ID = 1000134
export const KPMG_CUSTOMER_HEAD_ID = 1000095

export const SKYTECH_WHITE_LABEL_ID = 1 as const
export const MOBIT_WHITE_LABEL_ID = 9 as const

export const MIN_PRICE = 0.01 as const
export const MAX_DECIMAL_12_4 = 99999999.99 as const

export const LANGUAGE_FLAGS: Record<TranslationLang, string> = {
  en: '🇬🇧',
  fr: '🇫🇷',
  es: '🇪🇸',
  dk: '🇩🇰',
  se: '🇸🇪',
  no: '🇳🇴',
  de: '🇩🇪',
  fi: '🇫🇮',
  hu: '🇭🇺',
  pl: '🇵🇱',
}

export const COUNTRY_BY_LANG: Partial<Record<Locale, CountryName>> = {
  en: 'Great Britain',
  dk: 'Denmark',
  se: 'Sweden',
  no: 'Norway',
  fi: 'Finland',
}

export const COUNTRY_FLAGS: Partial<Record<CountryName, string>> = {
  Albania: '🇦🇱',
  Andorra: '🇦🇩',
  Austria: '🇦🇹',
  Belarus: '🇧🇾',
  Belgium: '🇧🇪',
  'Bosnia and Herzegovina': '🇧🇦',
  Bulgaria: '🇧🇬',
  China: '🇨🇳',
  Croatia: '🇭🇷',
  Cyprus: '🇨🇾',
  'Czech Republic': '🇨🇿',
  Denmark: '🇩🇰',
  Estonia: '🇪🇪',
  'Faroe Islands': '🇫🇴',
  Finland: '🇫🇮',
  France: '🇫🇷',
  Germany: '🇩🇪',
  Gibraltar: '🇬🇮',
  // Internal version of United Kingdom
  'Great Britain': '🇬🇧',
  Greece: '🇬🇷',
  Greenland: '🇬🇱',
  Guernsey: '🇬🇬',
  Hungary: '🇭🇺',
  Iceland: '🇮🇸',
  Ireland: '🇮🇪',
  'Isle of Man': '🇮🇲',
  Italy: '🇮🇹',
  Israel: '🇮🇱',
  Jersey: '🇯🇪',
  Kosovo: '🇽🇰',
  Latvia: '🇱🇻',
  Liechtenstein: '🇱🇮',
  Lithuania: '🇱🇹',
  Luxembourg: '🇱🇺',
  Malta: '🇲🇹',
  Moldova: '🇲🇩',
  Monaco: '🇲🇨',
  Montenegro: '🇲🇪',
  Netherlands: '🇳🇱',
  'North Macedonia': '🇲🇰',
  Norway: '🇳🇴',
  Poland: '🇵🇱',
  Portugal: '🇵🇹',
  Philippines: '🇵🇭',
  Romania: '🇷🇴',
  Russia: '🇷🇺',
  'San Marino': '🇸🇲',
  Serbia: '🇷🇸',
  Slovakia: '🇸🇰',
  Slovenia: '🇸🇮',
  Spain: '🇪🇸',
  'Svalbard and Jan Mayen': '🇸🇯',
  Sweden: '🇸🇪',
  Switzerland: '🇨🇭',
  Ukraine: '🇺🇦',
  'United States': '🇺🇸',
  'United Kingdom': '🇬🇧',
  'Vatican City': '🇻🇦',
}

export const countryOptions: { value: number; label: CountryName }[] = [
  {
    value: 1,
    label: 'United States',
  },
  {
    value: 31,
    label: 'Netherlands',
  },
  {
    value: 33,
    label: 'France',
  },
  {
    value: 34,
    label: 'Spain',
  },
  {
    value: 36,
    label: 'Hungary',
  },
  {
    value: 41,
    label: 'Switzerland',
  },
  {
    value: 44,
    label: 'Great Britain',
  },
  {
    value: 45,
    label: 'Denmark',
  },
  {
    value: 46,
    label: 'Sweden',
  },
  {
    value: 47,
    label: 'Norway',
  },
  {
    value: 48,
    label: 'Poland',
  },
  {
    value: 49,
    label: 'Germany',
  },
  {
    value: 63,
    label: 'Philippines',
  },
  {
    value: 86,
    label: 'China',
  },
  {
    value: 351,
    label: 'Portugal',
  },
  {
    value: 353,
    label: 'Ireland',
  },
  {
    value: 355,
    label: 'Albania',
  },
  {
    value: 358,
    label: 'Finland',
  },
  {
    value: 371,
    label: 'Latvia',
  },
  {
    value: 372,
    label: 'Estonia',
  },
  {
    value: 383,
    label: 'Kosovo',
  },
  { value: 386, label: 'Slovenia' },
  { value: 420, label: 'Czech Republic' },
  { value: 972, label: 'Israel' },
]

export const countryIdByCountryName: Partial<Record<CountryName, number>> = {
  'United States': 1,
  Netherlands: 31,
  France: 33,
  Spain: 34,
  Hungary: 36,
  Switzerland: 41,
  'Great Britain': 44,
  Denmark: 45,
  Sweden: 46,
  Norway: 47,
  Poland: 48,
  Germany: 49,
  Philippines: 63,
  China: 86,
  Albania: 355,
  Finland: 358,
  Latvia: 371,
  Estonia: 372,
  Kosovo: 383,
}
